import classNames from "classnames";
import { Localizer } from "infrastructure/localization/localizer";

type KompetenceKlarmeldtInfoProps = {
    klarmeldtAtDisplayString?: string;
    klarmeldtTilNavne?: string[];
    isSmall?: boolean;
    isBold?: boolean;
}

export const KompetenceKlarmeldtInfo = (props: KompetenceKlarmeldtInfoProps) => {
    const fontSize = props.isSmall ? 12 : 14;

    const klarmeldingText = !!props.klarmeldtAtDisplayString 
        ? `${Localizer.global_klarmeldtden().trimEnd()} ${props.klarmeldtAtDisplayString} ${Localizer.global_to().toLowerCase()}:` 
        : Localizer.klarmeldingerPage_klarmeldtUdenDato(); 

    const klarmeldtTil = !!props.klarmeldtAtDisplayString 
        ? (!!props.klarmeldtTilNavne && props.klarmeldtTilNavne.length !== 0) ? props.klarmeldtTilNavne : [Localizer.global_none()]
        : [];

    return (
        <div className="flex-row flex-container-row wrap align-items-center">
            <div className={classNames("margin-right-s d-flex", props.isBold && "font-weight-bold")} style={{ fontSize: fontSize }}>
                {klarmeldingText}
            </div>
            {klarmeldtTil?.map(navn =>
                <span key={navn} className="badge badge-pill badge-default padding-xs margin-right-s"> {navn}</span>
            )}
        </div>
    );
}
